"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Composer;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Composer(_ref) {
  let {
    onSend,
    isTyping,
    activeFeature,
    suggestions = [],
    mode = 'sidebar'
  } = _ref;
  const isStandalone = mode === 'standalone';
  const [text, setText] = (0, _react.useState)('');
  const textareaRef = (0, _react.useRef)(null);
  const placeholder = _constants.COMPOSER_PLACEHOLDERS[activeFeature] || _constants.COMPOSER_PLACEHOLDERS[_constants.FEATURES.GENERAL];
  (0, _react.useEffect)(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 160) + 'px';
  }, [text]);
  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  const handleSend = () => {
    const trimmed = text.trim();
    if (!trimmed || isTyping) return;
    onSend(trimmed);
    setText('');
    if (textareaRef.current) textareaRef.current.style.height = 'auto';
  };
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-px-3 tw-py-2 tw-pb-3 tw-bg-sa-surface tw-border-t tw-border-sa-border",
    style: isStandalone ? {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: 'transparent',
      borderTop: '1px solid rgba(0,0,0,0.06)',
      padding: '12px 32px 16px'
    } : undefined,
    children: [suggestions.length > 0 && (0, _jsxRuntime.jsx)("div", {
      className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2",
      style: isStandalone ? {
        maxWidth: '780px',
        width: '100%'
      } : undefined,
      children: suggestions.map(label => (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "tw-cursor-pointer tw-rounded-full tw-border tw-border-sa-border tw-bg-sa-primary-lt tw-px-3 tw-py-1.5 tw-text-[12px] tw-font-semibold tw-text-sa-primary tw-font-sa tw-transition-colors hover:tw-border-sa-primary hover:tw-bg-[#C0D0E6]",
        onClick: () => onSend(label),
        disabled: isTyping,
        children: label
      }, label))
    }), (0, _jsxRuntime.jsxs)("div", {
      className: "tw-flex tw-items-end tw-gap-2 tw-bg-sa-surface-alt tw-border-[1.5px] tw-border-sa-border tw-rounded-[22px] tw-px-4 tw-py-1.5 focus-within:tw-border-sa-primary tw-transition-colors tw-cursor-text",
      style: isStandalone ? {
        maxWidth: '780px',
        width: '100%',
        borderRadius: '16px',
        padding: '12px 20px',
        background: 'rgba(255,255,255,0.9)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(0,0,0,0.08)',
        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
        fontSize: '15px'
      } : undefined,
      onClick: () => {
        var _textareaRef$current;
        return (_textareaRef$current = textareaRef.current) === null || _textareaRef$current === void 0 ? void 0 : _textareaRef$current.focus();
      },
      children: [(0, _jsxRuntime.jsx)("textarea", {
        ref: textareaRef,
        className: "tw-flex-1 tw-border-none tw-outline-none tw-resize-none tw-bg-transparent tw-font-sa tw-text-sm tw-text-sa-text tw-max-h-40 tw-min-h-[36px] placeholder:tw-text-sa-text-muted",
        rows: 1,
        placeholder: placeholder,
        value: text,
        onChange: e => setText(e.target.value),
        onKeyDown: handleKeyDown,
        disabled: isTyping,
        "aria-label": "Message input"
      }), isTyping ? (0, _jsxRuntime.jsx)("button", {
        className: "tw-flex-shrink-0 tw-w-[34px] tw-h-[34px] tw-rounded-full tw-bg-sa-error tw-text-white tw-text-xs tw-inline-flex tw-items-center tw-justify-center tw-cursor-pointer tw-border-none tw-transition hover:tw-scale-105",
        type: "button",
        "aria-label": "Cancel",
        children: "\u25A0"
      }) : (0, _jsxRuntime.jsx)("button", {
        className: "tw-flex-shrink-0 tw-w-[34px] tw-h-[34px] tw-rounded-full tw-bg-sa-primary tw-text-white tw-inline-flex tw-items-center tw-justify-center tw-cursor-pointer tw-border-none tw-transition hover:tw-bg-sa-primary-h hover:tw-scale-105 disabled:tw-opacity-40 disabled:tw-cursor-default",
        type: "button",
        onClick: handleSend,
        disabled: !text.trim(),
        "aria-label": "Send message",
        children: (0, _jsxRuntime.jsx)("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 24 24",
          fill: "none",
          children: (0, _jsxRuntime.jsx)("path", {
            d: "M2 21l21-9L2 3v7l15 2-15 2v7z",
            fill: "currentColor"
          })
        })
      })]
    }), (0, _jsxRuntime.jsxs)("p", {
      style: {
        fontSize: isStandalone ? '11.5px' : '10.5px',
        color: '#64748b',
        textAlign: 'center',
        margin: isStandalone ? '10px auto 0' : '8px 0 0',
        maxWidth: isStandalone ? '780px' : undefined,
        lineHeight: 1.5,
        fontWeight: 500,
        letterSpacing: '0.01em'
      },
      children: [(0, _jsxRuntime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#94a3b8",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: {
          verticalAlign: '-2px',
          marginRight: '4px',
          display: 'inline'
        },
        children: [(0, _jsxRuntime.jsx)("circle", {
          cx: "12",
          cy: "12",
          r: "10"
        }), (0, _jsxRuntime.jsx)("line", {
          x1: "12",
          y1: "16",
          x2: "12",
          y2: "12"
        }), (0, _jsxRuntime.jsx)("line", {
          x1: "12",
          y1: "8",
          x2: "12.01",
          y2: "8"
        })]
      }), "AI-generated content \u2014 ", (0, _jsxRuntime.jsx)("span", {
        style: {
          fontWeight: 700,
          color: '#475569'
        },
        children: "review using your independent professional judgment"
      }), ". Do not rely on AI output alone."]
    })]
  });
}